import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import AttributeValueType from 'app/models/enums/AttributeValueType';
import { LocalProfileAttributeFormFactory } from '../../../../factories/local-profile-attribute-form.factory';
import Utils from '../../../../shared/utils';
import { BusinessCitationService } from '../../../../services/business-citation.service';
import { map, forkJoin, finalize } from 'rxjs';

type Attribute = Boo.BusinessCitations.Models.BusinessCitationProviderAttribute;
type AttributeMetadata = Boo.BusinessCitations.Models.BusinessCitationProviderAttributeMetadata;

@Component({
  selector: 'app-components-shared-local-profile-attributes',
  templateUrl: './attributes.component.html',
  styleUrls: ['./attributes.component.scss']
})
export class AttributesComponent implements OnChanges {
  @Input() isReadOnly = false;
  @Input() primaryCategory: number;
  @Input() countryId: number;
  @Input() businessCitationProviderId: number;
  @Input() profileAttributes: FormArray<FormGroup> = new FormArray([]);
  @Output() profileAttributesChange: EventEmitter<FormArray<FormGroup>> = new EventEmitter<FormArray<FormGroup>>();
  categoryAttributes: Attribute[] = [];
  availableAttributes: Attribute[] = [];
  selectedAttribute: Attribute;
  editedAttribute: FormGroup;

  attributeValueType = AttributeValueType;

  constructor(
    private businessCitationService: BusinessCitationService,
    private localProfileAttributeFormFactory: LocalProfileAttributeFormFactory) { }

  addAttribute() {
    if (!this.selectedAttribute) {
      return;
    }

    const attributeControl = this.localProfileAttributeFormFactory.createFormControl(this.selectedAttribute);
    this.profileAttributes.push(attributeControl);
    this.profileAttributes.markAsDirty();
    this.profileAttributesChange.emit(this.profileAttributes);
    this.editedAttribute = attributeControl;
    this.selectedAttribute = null;
    this.updateAttributes();
  }

  editAttribute(attribute: FormGroup) {
    this.editedAttribute = attribute;
  }

  removeAttribute(attribute: FormGroup) {
    this.profileAttributes.removeAt(this.profileAttributes.controls.indexOf(attribute));
    this.profileAttributes.markAsDirty();
    this.profileAttributesChange.emit(this.profileAttributes);
    this.updateAttributes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['primaryCategory']) {
      return;
    }    

    this.businessCitationService.getBusinessCitationProviderCategoryAttributes(this.primaryCategory, this.countryId, this.businessCitationProviderId)
    .pipe(finalize(() => this.updateAttributes()))
    .subscribe(result => {
      this.categoryAttributes = Utils.filterDuplicates(result,  (x, y) => x.ExternalId === y.ExternalId).sort((a, b) => a.DisplayName.localeCompare(b.DisplayName));
    });
  }

  private updateAttributes() {
    this.filterFormArray(this.profileAttributes, x => this.categoryAttributes.some(y => y.ExternalId === x.value.ExternalId));
    this.availableAttributes = this.categoryAttributes.filter(x => !this.profileAttributes.controls.some(y => y.value.ExternalId === x.ExternalId));
  }
  
  setRepeatedEnumValue(attribute: FormGroup, $event: AttributeMetadata[]) {
    attribute.controls.Value.setValue($event.map(x => x.Value).join(','));
  }

  private filterFormArray(formArray: FormArray, predicate: (control: AbstractControl) => boolean) {
    for (let i = formArray.length - 1; i >= 0; i--) {
      if (!predicate(formArray.at(i))) {
        formArray.removeAt(i);
      }
    }
  }
}